export const LOCALES = {
	HUF: 'hu-HU',
	EUR: 'de-DE',
	USD: 'en-US'
};

const formatAmount = (amount, currency) => {
	const locale = LOCALES[currency];
	const maximumFractionDigits = currency == 'HUF' ? 0 : 2;
	const formatter = new Intl.NumberFormat(locale, {
		style: 'currency',
		currency,
		minimumFractionDigits: 0,
		maximumFractionDigits
	});
	return formatter.format(amount);
};

export const useCurrency = () => ({ formatAmount });
